import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import WhatIfClientRedefinedLayout from './WhatIfClientRedefinedLayout';

const WhatIfClientRedefined = () => {
  const {
    pageContentCollection,
    isInitializing,
    pageContentLoadingError,
  } = usePageContentContext();

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection: pageContentCollection,
        layout: WhatIfClientRedefinedLayout,
      }}
      loading={isInitializing}
      loadingError={pageContentLoadingError}
    />
  );
};

export default WhatIfClientRedefined;
